import { render, staticRenderFns } from "./news.vue?vue&type=template&id=5f52e476&scoped=true"
import script from "./news.vue?vue&type=script&lang=ts"
export * from "./news.vue?vue&type=script&lang=ts"
import style0 from "./news.vue?vue&type=style&index=0&id=5f52e476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52e476",
  null
  
)

export default component.exports